"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const habit_1 = __importDefault(require("./habit"));
const getUserStore = (store) => store.user;
const getUser = (store) => getUserStore(store).user;
const getPending = (store) => getUserStore(store).pending;
const getAccountHabits = (store) => {
    const { accountHabits = {} } = getUserStore(store);
    return Object.values(accountHabits);
};
const getActiveAccountHabitIDs = (store) => {
    const accountHabits = getAccountHabits(store);
    return accountHabits.filter((item) => !!item.dateCommitmentEnd).map((acHabit) => acHabit.habit_id);
};
const getActiveHabitJourneys = (store) => {
    var _a;
    const journeys = habit_1.default.getHabitJourneys(store);
    const userHabits = (_a = getUser(store)) === null || _a === void 0 ? void 0 : _a.habits;
    const result = journeys.filter((journey) => 
    // @ts-ignore
    journey.getHabits.some((habitID) => userHabits === null || userHabits === void 0 ? void 0 : userHabits.includes(parseInt(habitID, 10))));
    return result;
};
exports.default = {
    getUser,
    getPending,
    getActiveAccountHabitIDs,
    getActiveHabitJourneys,
};
